// extracted by mini-css-extract-plugin
export default {"container":"Ll-z","freeShip":"Ml-z","privacy":"Nl-z"};